import { GrandImage } from 'ui'
import { Box } from '@chakra-ui/react'
import { type PaymentProviderName } from 'ecosystem'
import klarnaPaymentMethodsImg from './images/klarna_payment_methods.webp'
import nexiPaymentMethodsImg from './images/nexi_payment_methods.png'
import sveaPaymentMethodsImg from './images/svea_payment_methods.webp'

interface FooterPaymentLogoProps {
  paymentProviderName?: PaymentProviderName
}

export const FooterPaymentLogo = ({ paymentProviderName }: FooterPaymentLogoProps) => {
  switch (paymentProviderName ?? 'KLARNA') {
    case 'KLARNA':
      return <GrandImage alt="Klarna" src={klarnaPaymentMethodsImg} />
    case 'NEXI':
      return (
        <GrandImage
          alt="Nexi payment methods"
          src={nexiPaymentMethodsImg}
          maxW="min(600px, 100%)"
          sizes="(min-width: 600px) 600px, 100vw"
        />
      )
    case 'SVEA':
      return (
        <Box
          width={{ base: 'full', md: '500px' }}
          height={{ base: '100px', md: '200px' }}
          position="relative"
        >
          <GrandImage
            alt="Svea payment methods"
            src={sveaPaymentMethodsImg}
            fill
            objectFit="contain"
          />
        </Box>
      )
    // todo: add LEDYER logo
    case 'LEDYER':
      return <>LEDYER img</>
  }
}
